"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_CART_DETAILS = void 0;
const site_address_mock_1 = require("./site-address.mock");
exports.MOCK_CART_DETAILS = {
    billingAddress: site_address_mock_1.MOCK_SITE_ADDRESS,
    shippingAddress: site_address_mock_1.MOCK_SITE_ADDRESS,
};
//# sourceMappingURL=cart-details.mock.js.map